module.exports = __webpack_public_path__ + "img/prt0001.prt.2da398a1.jpg";